import React from "react";
import { FaCheckDouble } from "react-icons/fa6";

const Highlights = ({ data }) => {
  return (
    <section className="w-full py-6 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Heading */}
        <h2 className="text-center text-2xl md:text-3xl lg:text-4xl font-semibold text-[#6d8f0d]">
          Godrej Varanya - Highlights
        </h2>

        <div className="w-20 h-[2px] bg-[#6b8e23] mx-auto my-3"></div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-2 mt-8">
          {data.highlights.map((item, index) => (
            <div key={index} className="flex items-start gap-3">
              <FaCheckDouble className="text-[#6c8914] w-5 h-5 mt-1 shrink-0" />
              <p className="text-gray-700 text-sm md:text-base leading-relaxed">
                {item}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Highlights;
